import type { SourceSystem } from 'graphql-models';
import type { Factory } from './helpers';

const MOCK_SOURCE_SYSTEM: SourceSystem = {
  contactEmail: 'help@walden.com',
  contactName: 'Walden Support',
  contactPhone: '+1234567890',
  country: 'France',
  entity: 'Walden Inc.',
  entityName: 'Walden Headquarters',
  id: '1',
};

export const sourceSystemFactory: Factory<SourceSystem> = (overrides) => ({
  ...MOCK_SOURCE_SYSTEM,
  ...overrides,
});
